import { Logger, ValidationPipe } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';
import { AppModule } from './app/app.module';
import { validateEnv } from './app/config/env.validation';

async function bootstrap() {
  // Fail fast on bad/missing config, before anything else spins up, with a
  // message that says exactly what's wrong — not a confusing error the
  // first time something tries to use a missing env var.
  validateEnv(process.env);

  const app = await NestFactory.create(AppModule);

  // Origins are registered per-Application (see ApiKeyGuard), not known at
  // the transport level — CORS stays permissive here so any embedder's
  // preflight succeeds, and the guard is the actual enforcement point once
  // the real request (carrying its API key) lands.
  app.enableCors({ origin: true, credentials: false });

  app.setGlobalPrefix('v1');
  app.useGlobalPipes(new ValidationPipe({ transform: true, whitelist: true, forbidNonWhitelisted: true }));
  app.enableShutdownHooks();

  const port = process.env.CHAT_PORT ? Number(process.env.CHAT_PORT) : 3201;
  await app.listen(port);
  Logger.log(`chat-service running on: http://localhost:${port}/v1`);
}

bootstrap().catch((error) => {
  Logger.error(error instanceof Error ? error.message : error);
  process.exit(1);
});
